import React from "react";
import "./About.css";

export default function About(){
    return(
        <div className="about">
            <h1 className="about_title">What is ALUplanner about?</h1>
            <p>ALU Planner is a platform designed to help students manage and stay on track with their professional, educational and social life. It shows students their pending academic deadlines and events due in a particular period of time(Day, Week, Month, or year)
            </p>
            <div className="btn">
                <button className="try_out "><a href="https://login-kakaymi10.vercel.app" target="_blank">Try HisBot</a></button>
                <button className="try_out"><a href="https://login-kakaymi10.vercel.app" target="_blank">try HisBook</a></button>
            </div>
        </div>
    )
}